import { Box,  Typography } from "@mui/material";
import React from "react";
import img from "../../images/teamcard.png";
import Rating from "@mui/material/Rating";

export default function ReviewCard() {
  return (
    <>
      <Box className="newCareer-col-3">
        <Box sx={{ display: "flex", alignItems: "start", gap: 1 }}>
          <Box>
            <img src={img} alt="icon" style={{ height: "40px" }} />
          </Box>
          <Box>
            <Typography
              sx={{
                fontfamily: "Inter",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "40px",
              }}
            >
              Navdeep |{" "}
              <span style={{ fontWeight: 400, opacity: 0.5 }}>Lorem ipsum</span>{" "}
            </Typography>
            <Rating
              name="half-rating-read"
              defaultValue={4}
              precision={0.5}
              readOnly
            />
            <Typography
              sx={{
                fontfamily: "Inter",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              Lorem ipsum dolor sit amet consectetur. Viverra a porttitor mattis
              enim tristique donec tristique sapien.
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
